import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { PortalProductsStore, PortalProductsState } from './portal-products.store';

@Injectable({ providedIn: 'root' })
export class PortalProductsQuery extends QueryEntity<PortalProductsState> {
  constructor(protected store: PortalProductsStore) {
    super(store);
  }

  /** 
   * @deprecated Please use getAllProductsByProductType instead as this should not be an observable
   * Selects a list of portal porducts, filtered by a given product type */
  getProductsByProductType(productType: number) {
    return this.selectAll({
      filterBy: [entity => entity.ProductType === productType],
    });
  }

  /** Gets a list of portal porducts, filtered by a given product type */
  getAllProductsByProductType(productType: number, paidForOnly: boolean = false) {
    return this.getAll({
      filterBy: [entity => { 
        if (paidForOnly) {
          return entity.ProductType === productType && entity.MerchantPrice > 0
        } else {
          return entity.ProductType === productType;
        }
      }],
    });
  }
}
